import Swiper from 'swiper';
import { Navigation, Thumbs, Keyboard } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import 'swiper/css/keyboard';

document.addEventListener('DOMContentLoaded', function() {
	/**
	 * WooCommerce Single Product Gallery Functionality
	 *
	 * This module handles the initialisation of WooCommerce single product galleries
	 * using Swiper.js with responsive breakpoints and navigation controls whilst
	 * synchronising main slider and thumbnail slider.
	 */
	const woocommerceProductGallery = document.querySelector('.single-product .woocommerce-product-gallery');
	if (woocommerceProductGallery) {
		/**
		 * Initialises the Swiper instance for WooCommerce single product gallery
		 *
		 * @function initWooCommerceSwiper
		 * @returns {void}
		 */
		function initWooCommerceSwiper() {
			const thumbSwiper = new Swiper(woocommerceProductGallery.querySelector('.swiper.product-gallery-thumbnails'), {
				modules: [Navigation],
				freeMode: true,
				slidesPerView: 2,
				spaceBetween: 16,
				watchSlidesProgress: true,
				breakpoints: {
					640: { slidesPerView: 3 },
					1200: { slidesPerView: 4 },
				},
				navigation: {
					nextEl: document.querySelector('.swiper-button-next'),
					prevEl: document.querySelector('.swiper-button-prev'),
				},

			});
			const mainSwiper = new Swiper(woocommerceProductGallery.querySelector('.swiper.product-gallery-main'), {
				modules: [Keyboard, Thumbs],
				thumbs: {
					swiper: thumbSwiper,
				},
				keyboard: {
					enabled: true,
				},
				allowTouchMove: true,
			});

			/**
			 * Updates the visibility of the Swiper navigation buttons.
			 *
			 * The navigation buttons are shown only if the total number of slides
			 * is greater than the number of slides visible per view in the thumbnail gallery.
			 * This is checked on initialisation and on breakpoint changes.
			 */
			function updateNavigationVisibility() {
				const slidesPerView = thumbSwiper.params.slidesPerView;
				const totalSlides = thumbSwiper.slides.length;
				const navigationContainer = thumbSwiper.navigation.nextEl.parentElement;

				if (navigationContainer) {
					if (totalSlides > slidesPerView) {
						console.log("totalSlides: " + totalSlides);
						console.log("slidesPerView: " + slidesPerView);
						navigationContainer.classList.remove('hidden');
					} else {
						navigationContainer.classList.add('hidden');
					}
				}
			}

			updateNavigationVisibility();

			thumbSwiper.on('breakpoint', function() {
				updateNavigationVisibility();
			});
		}

		initWooCommerceSwiper();
	}
});
